import React, { useEffect, useRef, useState } from 'react';
import '../../styles/CategoryFilter.css';

export const CATEGORY_ICONS = {
  scissors: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6" cy="6" r="3" /><circle cx="6" cy="18" r="3" />
      <line x1="20" y1="4" x2="8.12" y2="15.88" /><line x1="14.47" y1="14.48" x2="20" y2="20" />
      <line x1="8.12" y1="8.12" x2="12" y2="12" />
    </svg>
  ),
  'nail-polish': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 2h4v6l2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4l2-2V2z" />
      <path d="M10 16v4a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2v-4" />
    </svg>
  ),
};

function CategoryFilter({ categories, selectedCategories, onChange }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('pointerdown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('pointerdown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const toggleCategory = (categoryId) => {
    const selected = selectedCategories.some(
      (value) => String(value) === String(categoryId)
    );
    onChange(
      selected
        ? selectedCategories.filter((value) => String(value) !== String(categoryId))
        : [...selectedCategories, categoryId]
    );
  };

  if (!categories.length) return null;

  return (
    <div className="category-dropdown" ref={rootRef}>
      <button
        type="button"
        className={`category-dropdown-trigger${selectedCategories.length ? ' active' : ''}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span>
          {selectedCategories.length
            ? `الفئات (${selectedCategories.length})`
            : 'الفئات'}
        </span>
        <span className="category-dropdown-chevron" aria-hidden="true">⌄</span>
      </button>

      {open && (
        <div className="category-dropdown-panel" role="menu" aria-label="فئات المحلات">
          <button
            type="button"
            className={`category-dropdown-all${selectedCategories.length === 0 ? ' active' : ''}`}
            onClick={() => onChange([])}
          >
            الكل
          </button>

          {categories.map((category) => {
            const checked = selectedCategories.some(
              (value) => String(value) === String(category.id)
            );

            return (
              <label key={category.id} className="category-dropdown-option">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => toggleCategory(category.id)}
                />
                {category.icon && CATEGORY_ICONS[category.icon] && (
                  <span className="category-filter-icon">
                    {CATEGORY_ICONS[category.icon]}
                  </span>
                )}
                <span>{category.name_ar}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default CategoryFilter;
